import httpClient2 from "configs/httpClient2";
import httpClient from "configs/httpClient";
import { localStorageHelper } from "utils";

export const authTokenKey = process.env.REACT_APP_ACCESS_TOKEN_KEY!;

export enum MethodType {
  POST = "POST",
  GET = "GET",
  PUT = "PUT",
  DELETE = "DELETE",
  PATCH = "PATCH",
}

const id = localStorageHelper.getItem("id");

export const URI = {
  AUTH: {
    LOGIN: "/super_city_web_api_v1/users/login",
    FORGOT_PASSWORD: "/super_city_web_api_v1/users/forgot_password",
    RESETPASSWORD: "/super_city_web_api_v1/users/password_reset",
    CHANGE_PASSWORD: "/super_city_web_api_v1/users/update_password",
    VERIFY_RESET_TOKEN:
      "/super_city_web_api_v1/users/verify_reset_password_token",
  },
  PATIENTS: {
    PATIENTS_LIST: "/super_city_web_api_v1/patients",
    DOWNLOAD_PATIENTS_CSV: "/super_city_web_api_v1/patients/csv_download",
    DELETE_PATIENT: "/super_city_web_api_v1/patients/delete",
    SUBSCRIBE_SUPER_CITY: (patient_id: string) =>
      `/super_city_web_api_v1/patients/subcripbe?patient_ids=${patient_id}`,
  },
  CONSULTATIONS: {
    CONSULTATION_LIST: "/super_city_web_api_v1/consultations",
    CONSULTATION_DETAILS: (consultation_id: number) =>
      `/super_city_web_api_v1/consultations/${consultation_id}`,
    DOWNLOAD_CONSULTATION_CSV:
      "/super_city_web_api_v1/consultations/csv_download",
  },
  CONSENT_STATEMENT: {
    GET_CONSENT_STATEMENT: "/super_city_web_api_v1/terms",
    POST_CONSENT_STATEMENT: "/super_city_web_api_v1/terms/upsert",
  },
  SETTING: {
    INFO: "/super_city_web_api_v1/settings",
    DEFAULT: "/super_city_web_api_v1/settings/upsert",
    VERIFY_OTP: "/super_city_web_api_v1/temp_patient_registrations/verify_otp",
    VOICE_CALL: "/super_city_web_api_v1/temp_patient_registrations/voice_call",
    VERIFY_MOBILE_NUMBER:
      "/super_city_web_api_v1/temp_patient_registrations/verify_mobible_number",
    PATIENT_REGISTRATION: "/super_city_web_api_v1/patient_registrations",
  },
  DASHBOARD: {
    DASHBOARD_INFO: "/super_city_web_api_v1/dashboards",
  },
  MESSAGE_MANAGEMENT: {
    GET_ACTIVITY_FILTER: "/super_city_web_api_v1/send_messages/activity_list",
    GET_CLASS_FILTER: "/super_city_web_api_v1/send_messages/class_list",
    GET_TEMPERATURE_FILTER:
      "/super_city_web_api_v1/send_messages/temperature_list",
    GET_ATTENDANCE_FILTER: "/super_city_web_api_v1/send_messages/attendance",
    GET_STUDENT_LIST: "/super_city_web_api_v1/send_messages",
    GET_MESSAGE_HISTORY_LIST: "/super_city_web_api_v1/send_messages/histories",
    GET_MESSAGE_HISTORY_DETAIL:
      "/super_city_web_api_v1/send_messages/history_detail",
    SEND_MESSAGE: "/super_city_web_api_v1/send_messages",
    SEARCH_CONDITION:
      "/super_city_web_api_v1/send_messages/search_condition_status",
    GET_READ_HISTORY_LIST: "/super_city_web_api_v1/send_messages/read_history",
    PUSH_NOTIFICATION:
      "/super_city_web_api_v1/send_messages/remind_push_notification",
    UPDATE_MESSAGE: (id: number) =>
      `/super_city_web_api_v1/send_messages/${id}`,
    DELETE_MESSAGE: (id: number) =>
      `/super_city_web_api_v1/send_messages/${id}/delete`,
    RESEND_MESSAGE: `/super_city_web_api_v1/send_messages/resend_failed`,
  },
};

const getMethod = async (url: string, params: any) => {
  return httpClient.get(url, { params });
};

const postMethod = async (url: string, params: any) => {
  return httpClient.post(url, params);
};

const putMethod = async (url: string, params: any) => {
  return httpClient.put(url, params);
};

const patchMethod = async (url: string, params: any) => {
  return httpClient.patch(url, params);
};

const deleteMethod = async (url: string, params: any) => {
  return httpClient.delete(url, { params });
};

const methods: any = {
  GET: (url: string, params: any) => getMethod(url, params),
  POST: (url: string, params: any) => postMethod(url, params),
  PUT: (url: string, params: any) => putMethod(url, params),
  DELETE: (url: string, params: any) => deleteMethod(url, params),
  PATCH: (url: string, params: any) => patchMethod(url, params),
};

export const createApiCall = async (
  method: string,
  url: string,
  params = {}
) => {
  const { data } = await methods[method](url, params);
  return data;
};
